import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps } from '@material-ui/core';

import { Icon, IconProps } from './Icon';

interface IconButtonProps extends MuiIconButtonProps {
  icon: string;
  iconProps?: Omit<IconProps, 'children'>;
}

export const IconButton = ({ icon, iconProps, ...props }: IconButtonProps) => {
  return (
    <MuiIconButton {...props}>
      <Icon {...iconProps}>{icon}</Icon>
    </MuiIconButton>
  );
};
